import React from 'react';
import { Card, CardContent, Box, makeStyles } from '@material-ui/core';

export interface KPICardProps {
    label: string;
    value: React.ReactNode;
    sub: string;
    accentBarColor?: string;
    bgColor?: string;
}

const useStyles = makeStyles((theme) => ({
    card: {
        borderRadius: 6,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: `0 1px 4px ${theme.palette.background.default}`,
        position: 'relative',
        overflow: 'hidden',
        transition: 'border-color 0.2s, box-shadow 0.2s',
        '& .MuiCardContent-root': {
            padding: '12px 14px',
        },
    },
    accentBar: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: 3,
    },
    label: {
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.4px',
        textTransform: 'uppercase',
        color: theme.palette.text.hint,
        marginBottom: theme.spacing(0.5),
    },
    value: {
        fontSize: 24,
        fontWeight: 700,
        color: theme.palette.primary.dark,
        marginBottom: theme.spacing(0.5),
    },
    subText: {
        fontSize: 11,
        color: theme.palette.text.hint,
        whiteSpace: 'pre-line',
    },
}));

const KPICard: React.FC<KPICardProps> = ({ label, value, sub, accentBarColor, bgColor }) => {
    const classes = useStyles();

    return (
        <Card className={classes.card} style={{ backgroundColor: bgColor }}>
            {accentBarColor && (
                <Box className={classes.accentBar} style={{ background: accentBarColor }} />
            )}

            <CardContent>
                <div className={classes.label}>{label}</div>
                <div className={classes.value}>{value}</div>
                <div className={classes.subText}>{sub}</div>
            </CardContent>
        </Card>
    );
};

export default KPICard;
